import React from 'react'
import ReactSelect from 'react-select'
import { useRef, forwardRef, useImperativeHandle } from 'react';
import { MixpanelTracking } from '../../MixPanel';

const IndicatorSeparator = () => null;

const Select = forwardRef((props : any, ref : any) => {
    let customSelectRef : any = useRef(null)

    const background = props.background || ''
    const additionalStyles = props.additionalStyles || {}
    const suffix = props.suffix || ''
    const multi = props.multi || false
    const placeholderStyles = props.placeholderStyles || {}

    const handleOnFocus = () => {
        const mixPanelData = {
            multiSelect : multi,
            selectName : props.name ? props.name : ''
        }
        MixpanelTracking.getInstance().trackSelect(mixPanelData);
    }

    const handleOnChange = (selected : any) => {
        if(props.onChange && selected)
            props.onChange(selected);

        const mixPanelData = {
            multiSelect : multi,
            selectName : props.name ? props.name : '',
            selectedData : selected
        }
        MixpanelTracking.getInstance().trackSelect(mixPanelData, true);
    }
    
    return (
        <>
            <ReactSelect
                onFocus={handleOnFocus}
                defaultValue={props.defaultValue || null}
                value = {props.value}
                ref={customSelectRef}
                instanceId = 's'
                placeholder={props.placeholder}
                components={{
                    IndicatorSeparator,
                    IndicatorsContainer: ({ children, ...props } : any) => {
                        return (
                            suffix
                        )
                    }
                }}
                isSearchable = {props.search}
                isMulti = {multi}
                name={props.name}
                className="basic-multi-select"
                options={props.items}
                styles={{
                    control: (baseStyles : any, state : any) => ({
                        ...baseStyles,
                        ...additionalStyles,
                        backgroundColor: background,
                        cursor : 'pointer'
                        
                    }),

                    input : (baseStyles : any, state : any) => ({
                        ...baseStyles,
                        ...additionalStyles,
                        color : props.color
                    }),

                    placeholder : (baseStyles : any, state : any) => ({
                        ...baseStyles,
                        ...placeholderStyles,
                    }),

                    option : (baseStyles : any, state : any) => ({
                        ...baseStyles,
                        color : 'black',
                        ":hover" : {
                            background : 'rgba(189,197,209,.3)',
                            cursor : 'pointer'
                        },
                        backgroundColor: state.isSelected ? "rgba(189,197,209,.3)" : "white",
                    }),

                    singleValue : (baseStyles : any, state : any) => ({
                        ...baseStyles,
                        color : props.valueColor || 'black'
                    })
                }}
                onChange = {handleOnChange}
                theme={theme => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      neutral50: props.placeholderColor || '#9ca3af', 
                      primary: props.selectedColor // Placeholder color
                    }
                })}
            />
            {
                props.error && props.touched &&
                <small className='display-block text-error'> {props.error} </small>
            }
        </>
    )
})

Select.defaultProps = {
    items : [],
    search : false,
    color : 'black',
    error : '',
    placeholder : 'select',
    selectedColor : '',
    value : null,
    defaultValue : ''
}

export default Select